import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Product } from '@shared/models/product.model';
import { ModalController } from '@ionic/angular';
import { EasyPricingUpdate } from '@usf/ngrx-pricing';
import { ProductDetailViewModel } from '../../../product-detail/models/product-detail-view-model';

@Component({
  selector: 'app-pme-right-rail',
  templateUrl: './pme-right-rail.component.html',
  styleUrls: ['./pme-right-rail.component.scss'],
})
export class PMERightRailComponent implements OnChanges {
  @Input() product: Product;
  @Input() isMobile = false;
  @Output() productDetailsClick = new EventEmitter<void>();
  @Output() closeSidebar = new EventEmitter<void>();
  @Output() priceChanged = new EventEmitter<EasyPricingUpdate>();

  customPrice = '0.00';

  // Below relies on tandem working
  isTandemWorking = false;

  // REMOVE ME - IM JUST MOCK DATA
  targetPercents = ['1', '2', '3', '4'];

  // REMOVE ME - IM JUST MOCK DATA
  quantities = ['1', '1', '1', '1'];

  // REMOVE ME - IM JUST MOCK DATA
  MTD = ['cpr', 'cpr', 'cpr', 'cpr'];

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product']) {
      if (this.product?.imageThumbnail) {
        this.checkImageExists(this.product.imageThumbnail).then(exists => {
          if (!exists) {
            this.product.imageThumbnail = null;
          } else {
            this.product.imageThumbnail = this.product.imageThumbnail;
          }
        });
      }
    }
  }

  onCloseSidebar() {
    this.closeSidebar.emit();
  }

  getAlternativeThumbnail(imageUrl: string): string {
    return 'assets/images/default-product-image.png';
  }

  checkImageExists(url: string): Promise<boolean> {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  }

  productDetailsButtonClick() {
    this.productDetailsClick.emit();
  }

  onCustomPriceChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const customPrice = parseFloat(value?.replace(/[^0-9.]/g, ''));

    if (
      customPrice &&
      customPrice !==
        this.product?.easyPricingViewModel?.currentPrice?.unitPrice
    ) {
      this.priceChanged.emit({
        productNumber: this.product.productNumber,
        price: customPrice,
        isCustomUpdate: true,
        productUOM: this.product.summary.priceUom,
      });
    }
  }

  selectTargetPrice(): void {
    this.priceChanged.emit({
      productNumber: this.product.productNumber,
      price: this.product.easyPricingViewModel.targetCasePrice,
      isCustomUpdate: false,
      productUOM: this.product.summary.priceUom,
    });
  }

  transformProductToProductDetail() {
    return {
      ...this.product,
    } as ProductDetailViewModel;
  }
}
